/**
 * Horário de recebimento de propostas devolvido por
 * `GET /properties/:id/proposals-window`.
 */
export interface ProposalsWindow {
  /** Instante de abertura em ISO/UTC; null quando não há restrição. */
  startAt: string | null;
  /** Hora de parede no fuso da entidade, para o datetime picker. */
  startAtWallClock: string | null;
  /** Etiqueta pronta a mostrar ('DD-MM-YYYY HH:mm'). */
  startAtLabel: string | null;
  timezone: string;
  /** Quem pode editar o empreendimento não é travado. */
  canBypass: boolean;
  blocked: boolean;
  /** Milissegundos até abrir, medidos no relógio do servidor. */
  msUntilOpen: number | null;
}

/** Limite do setTimeout (~24,8 dias); acima disto o browser dispara de imediato. */
const MAX_TIMEOUT_MS = 2147483647;

/**
 * Agenda o desbloqueio do botão para o momento exato da abertura, para que uma
 * página deixada aberta não fique presa em "Propostas a partir de ...".
 *
 * O atraso vem do servidor (`msUntilOpen`), por isso não depende do relógio do
 * cliente estar certo. Ainda assim é só a UI a ser otimista: quem submeter cedo
 * por causa de um relógio adiantado leva com o 400 do servidor.
 *
 * Devolve o handle para limpar em `ngOnDestroy`, ou null se não houver nada a
 * agendar.
 */
export function scheduleProposalsWindowUnlock(
  window: ProposalsWindow | any,
  onUnlock: () => void,
): any {
  const ms = Number(window?.msUntilOpen ?? 0);
  if (!window?.blocked || !(ms > 0) || ms > MAX_TIMEOUT_MS) {
    return null;
  }
  // Uma margem pequena evita desbloquear um instante antes do servidor.
  return setTimeout(onUnlock, ms + 1000);
}
